import { ErrorMessage } from '@hookform/error-message'
import { Col, Flex, Form, Input, Row, Typography } from 'antd'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
interface FormPayeeProps {
  control: any
  errors: any
  isViewOnly?: boolean
  setValue?: any
}

function FormPayee(props: Readonly<FormPayeeProps>) {
  const { t } = useTranslation()
  const { control, errors, isViewOnly } = props

  return (
    <Flex vertical>
      <Row gutter={24}>
        <Col span={24}>
          <Row gutter={24}>
            <Col span={24} md={24} xl={12}>
              <Form.Item
                label={t('PayeeMatchParameters:addNewPayeeMatchParameters.label.profileName')}
                className='isRequired'
              >
                <Controller
                  name='profileName'
                  control={control}
                  render={({ field, fieldState }) => (
                    <Input
                      {...field}
                      status={fieldState.error ? 'error' : ''}
                      placeholder={t('PayeeMatchParameters:addNewPayeeMatchParameters.placeholder.enterProfileName')}
                      onChange={(e) => {
                        field.onChange(e?.target?.value)
                      }}
                      onBlur={(e) => {
                        field.onChange(e?.target?.value?.trim())
                      }}
                      maxLength={50}
                      className={isViewOnly ? 'ant-input-view-only' : ''}
                      disabled={isViewOnly}
                    />
                  )}
                />
                <Typography className='error-message'>
                  <ErrorMessage errors={errors} name='profileName' />
                </Typography>
              </Form.Item>
            </Col>
            <Col span={24} md={24} xl={12}>
              <Form.Item
                label={t(
                  'PayeeMatchParameters:addNewPayeeMatchParameters.label.createExceptionsForConfidenceScoresBelowDefault',
                )}
                className='isRequired'
              >
                <Controller
                  name='createExceptionsForConfidenceScoresBelowDefault'
                  control={control}
                  render={({ field, fieldState }) => (
                    <Input
                      {...field}
                      status={fieldState.error ? 'error' : ''}
                      placeholder={t(
                        'PayeeMatchParameters:addNewPayeeMatchParameters.placeholder.enterCreateExceptionsForConfidenceScoresBelowDefault',
                      )}
                      onBlur={(e) => {
                        field.onChange(e?.target?.value?.trim())
                      }}
                      onChange={(e) => {
                        let inputValue = e.target.value
                        inputValue = inputValue.trim().replace(/\D/g, '')
                        field.onChange(inputValue)
                      }}
                      maxLength={3}
                      suffix='%'
                      disabled={isViewOnly}
                    />
                  )}
                />
                <Typography className='error-message'>
                  <ErrorMessage errors={errors} name='createExceptionsForConfidenceScoresBelowDefault' />
                </Typography>
              </Form.Item>
            </Col>
          </Row>

          {/* Team wants to keep this code to use in the future if needed /*}
          {/* <Row gutter={24}>
            <Col span={12}>
              <Form.Item valuePropName='checked'>
                <Controller
                  name='detectAdditionalNames'
                  control={control}
                  render={({ field }) => (
                    <Checkbox {...field} checked={field.value} disabled={isViewOnly}>
                      {t('PayeeMatchParameters:addNewPayeeMatchParameters.label.detectAdditionalNames')}
                    </Checkbox>
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <Controller
                  render={({ field, fieldState }) => (
                    <Tooltip title={isViewOnly ? field.value : null} placement="topRight" >
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : ''}
                        placeholder={
                          !isViewOnly
                            ? t('PayeeMatchParameters:addNewPayeeMatchParameters.placeholder.enterAdditionalNames')
                            : ''
                        }
                        onChange={(e) => {
                          field.onChange(e?.target?.value)
                        }}
                        onBlur={(e) => {
                          field.onChange(e?.target?.value?.trim())
                        }}
                        maxLength={255}
                        className={isViewOnly ? 'ant-input-view-only' : ''}
                        disabled={!checkDetect || isViewOnly}
                      />
                    </Tooltip>
                  )}
                  name='enterAdditionalNames'
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
                        Required_Field: t(
                          'PayeeMatchParameters:addNewPayeeMatchParameters.placeholder.enterAdditionalNames',
                        ),
                      }),
                    },
                  }}
                />
                <Typography className='error-message'>
                  <ErrorMessage errors={errors} name='enterAdditionalNames' />
                </Typography>
              </Form.Item>
            </Col>
          </Row> */}
        </Col>
      </Row>
    </Flex>
  )
}

export default FormPayee
